import ApiService from "src/util/api.service";
import type { CommandHistoryRecord } from "./commandHistoryService";
import { getLanguageHeaders } from "./commonLanguageHeader";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface CommandLookupItem {
  id: number;
  internalName: string;
  commandTransport: string;
}

export interface CommandDetail {
  id: number;
  internalName: string;
  commandForms?: string[];
  commandTransport: string;
  expire: number;
}

export interface UpdateCommandPayload {
  expire: number;
}

export type CommandSchedulerStatus = 0 | 1 | 2;

interface SendCommandBasePayload {
  commandId: number;
  params: Record<string, string>;
}

export type SendCommandPayload =
  | (SendCommandBasePayload & {
      scheduledCommand: false;
    })
  | (SendCommandBasePayload & {
      scheduledCommand: true;
      schedulerStatus: CommandSchedulerStatus;
      schedulerType: "BASE";
    });

export type CommandStatus = CommandHistoryRecord["status"];

export type CommandExecutionResponse = CommandHistoryRecord;

export interface CommandHistoryEvent {
  status: CommandStatus;
}

export const getCommandLookup = (
  modelId: string | number,
  language?: string,
) =>
  ApiService.get<{ response: CommandLookupItem[] }>(
    `${ServicesUrlEndpoints.COMMANDS.LOOKUP_BY_MODEL}/${modelId}/lookup`,
    {
      params: {
        commandType: "BASE",
      },
      ...getLanguageHeaders(language),
    },
  );

export const getCommandById = (
  commandId: string | number,
  language?: string,
) =>
  ApiService.get<{ response: CommandDetail }>(
    `${ServicesUrlEndpoints.COMMANDS.DETAIL}/${commandId}`,
    getLanguageHeaders(language),
  );

export const updateCommand = (
  commandId: string | number,
  payload: UpdateCommandPayload,
  language?: string,
) =>
  ApiService.patch(
    `${ServicesUrlEndpoints.COMMANDS.UPDATE}/${commandId}`,
    payload,
    getLanguageHeaders(language),
  );

export const sendCommandByVehicleId = (
  vehicleId: string | number,
  payload: SendCommandPayload,
  language?: string,
) =>
  ApiService.post<{ response: CommandExecutionResponse }>(
    `${ServicesUrlEndpoints.COMMANDS.SEND}/${vehicleId}/send`,
    payload,
    getLanguageHeaders(language),
  );

export const getCommandHistoryEventUrl = (historyId: string | number) =>
  `${ServicesUrlEndpoints.COMMANDS.HISTORY_EVENTS}/${historyId}`;
